import { defineStore } from 'pinia';

function menusFilter(menus, baseUrl = '', baseName = '') {
    const baseUrlPath = baseUrl ? `${baseUrl}/` : '';
    const baseNamePath = baseName ? `${baseName}/` : '';
    return menus.reduce((pre, cur) => {
        if (cur.children && cur.children.length > 0) {
            cur.children = menusFilter(
                cur.children,
                `${baseUrlPath}${cur.path || ''}`,
                `${baseNamePath}${cur.meta.title || ''}`
            );
        }
        if (cur.meta && !cur.meta.isHiddenForMenu && cur.meta.title) {
            const params = {
                title: cur.meta.title,
                path: `${baseUrlPath}${cur.path}`,
                namePath: `${baseNamePath}${cur.meta.title}`,
                icon: cur.meta.icon || ''
            };
            cur.children && (params.children = cur.children);
            pre.push(params);
        }
        return pre;
    }, []);
}

const useMenusStore = defineStore('menusStore', {
    state: () => ({
        menus: [], // 菜单
        isHiddenMenus: false // 隐藏菜单
    }),
    actions: {
        setMenus(routes) {
            this.menus = menusFilter(routes);
        }
    }
});

export default useMenusStore;
